import { quoteForInnerShell } from "./shellQuote";

const ZIP_MAGIC = "504b0304";
export const NO_HEX_TOOL = "__NO_HEX_TOOL__";

export type ApkFileCheck =
  | { ok: true; size: number; magicChecked: boolean }
  | { ok: false; detail: string; error: string };

export function checkApkFile(
  remotePath: string,
  sizeOutput: string,
  magicOutput: string,
): ApkFileCheck {
  if (sizeOutput.includes("__ERR__")) {
    return {
      ok: false,
      detail: `File missing at ${remotePath}`,
      error: "Download failed or file missing",
    };
  }
  const size = Number(sizeOutput);
  if (!Number.isFinite(size) || size <= 0) {
    return {
      ok: false,
      detail: `Invalid file size: ${sizeOutput}`,
      error: "Invalid downloaded file size: " + sizeOutput,
    };
  }
  if (magicOutput === NO_HEX_TOOL) return { ok: true, size, magicChecked: false };
  if (!magicOutput.toLowerCase().startsWith(ZIP_MAGIC)) {
    return {
      ok: false,
      detail: `File at ${remotePath} is not a valid APK (magic=${magicOutput || "<empty>"}, size=${size} bytes)`,
      error: `Downloaded file is not a valid APK (magic=${magicOutput})`,
    };
  }
  return { ok: true, size, magicChecked: true };
}

// Build a shell command that tries curl then wget then toybox/busybox wget.
// Each branch must exit 0 only on a true success; we emit __OK__/__FAIL__
// so we can gate on exit status, not stdout text matching.
// curl uses -f so HTTP 4xx/5xx don't produce a bogus "downloaded" error page.
// toybox/busybox applet presence is detected via `--list`, since invoking
// `wget` with no args exits non-zero even when supported.
// adb's shell expands the double-quoted script before the inner sh runs it, so the
// inner script's own variables are escaped.
export function onDeviceDownloadCommand(remotePath: string, url: string): string {
  const path = quoteForInnerShell(remotePath);
  const source = quoteForInnerShell(url);
  return (
    `sh -c "{ if command -v curl >/dev/null 2>&1; then ` +
    `curl -fL --retry 2 --max-time 180 -o ${path} ${source}; ` +
    `elif command -v wget >/dev/null 2>&1; then wget -O ${path} ${source}; ` +
    `elif command -v toybox >/dev/null 2>&1 && toybox --list 2>/dev/null | grep -qw wget; then toybox wget -O ${path} ${source}; ` +
    `elif command -v busybox >/dev/null 2>&1 && busybox --list 2>/dev/null | grep -qw wget; then busybox wget -O ${path} ${source}; ` +
    `else echo NO_DOWNLOADER; exit 127; fi; } 2>&1; rc=\\$?; ` +
    `if [ \\$rc -eq 0 ]; then echo __OK__; else echo __FAIL__:\\$rc; fi"`
  );
}
